import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {UOMUtil} from '../../utils/uomUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {attachWorkspaceFilterState, readTypeAheadUnitState, restoreTypeAheadUnitState, resolveUnitByCode} from '../../utils/workspaceStateUtil.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {BaseComponent} from '../basecomponent.js';
import {DataTools} from './dataTools.js';


/* global customElements */
class AdminDistanceSummaryGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var distanceSummaryGrid = this;
		setTimeout(function(){
			distanceSummaryGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var distanceSummaryGrid = this;
	
		var lookupRequestId = 0;
		var loadReferenceLookup = function (refType, lookupValue, selectedUnitId) {
			var requestId = ++lookupRequestId;
			var paging = {
				max: 100
			};
			if (lookupValue) {
				paging.filterField = 'description';
				paging.filterValue = lookupValue;
			}

			var unitField = ElementUtil.query(toolbarFilter, 'filterTractorId');
			if (!distanceSummaryGrid.selectedCompanyId) {
				unitField.items = [];
				return Promise.resolve();
			}

			return UnitService.getUnitLookupService().getUnitsForCompany(distanceSummaryGrid.selectedCompanyId, refType, paging).then(function (units) {
				if (requestId !== lookupRequestId) {
					return;
				}

				units.data = units.data || [];

				var applyItems = function(items) {
					if (requestId !== lookupRequestId) {
						return;
					}
					unitField.items = items;
					if (selectedUnitId) {
						unitField.value = selectedUnitId;
					}
				};

				if (selectedUnitId) {
					var found = units.data.some(function(unit) {
						return unit.code === selectedUnitId;
					});
					if (!found) {
						return UnitService.getUnitLookupService().getUnitsForCompany(distanceSummaryGrid.selectedCompanyId, refType, {
							max: 1,
							filterField: 'code',
							filterValue: selectedUnitId
						}).then(function(matched) {
							if (matched && matched.data && matched.data.length) {
								units.data = matched.data.concat(units.data);
							}
							applyItems(units.data);
						});
					}
				}
				applyItems(units.data);
			});
		};	
	
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [	
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterCompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {
						if (distanceSummaryGrid.accountmanagement) {
							Service.getAccountManagementService().getManagedCompanies().then(function(data){
								var lookups = []; 
								data.forEach(function(c) {
									lookups.push({
										code: c.companyId,
										description: c.companyName
									});
								});
								combo.items = lookups;
							});
						} else {
							Service.getCompanyService().getCompaniesLookup().then(function(data){
								combo.items = data;
							});
						}
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							distanceSummaryGrid.selectedCompanyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;
							loadReferenceLookup('TRACTOR');
							ElementUtil.query(toolbarFilter, 'filterTractorId').value = '';
							distanceSummaryGrid.actionRefresh();
						}
					}					
				},				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterTractorId',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Tractor',
					'item-value-path': 'code',
					'item-label-path': 'description',									
					postinit: function(combo) {																	
					},
					placeHolder: 'Select',
					listeners: {
						input: {
							fn: function(e) {
								loadReferenceLookup('TRACTOR', e.target.value);	
							},
							buffer: 500
						},
						change: function() {
							distanceSummaryGrid.actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Start Date',												
					name: 'filterStartDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.startPreviousMonth());	
					}()
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'End Date',												
					name: 'filterEndDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.endPreviousMonth());	
					}()
				}				
			]
		});	
	
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							distanceSummaryGrid.actionRefresh();
						}
					}
				}											
			]
		});
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},	
				{						
					path: 'tractorRefNo',
					header: 'Tractor Ref No',
					width: '7em'
				},
				{						
					path: 'periodEndUtcDts',
					header: 'Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.periodEndUtcDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'stateProvCode',
					header: 'State',
					width: '7em'
				},
				{						
					path: 'countryCode',
					header: 'Country',
					width: '7em'
				},
				{						
					path: 'travelDistance',
					header: 'Distance',
					width: '7em',
					'text-align': 'end'
				},
				{						
					path: 'tollDistance',
					header: 'Toll Distance',
					width: '7em',
					'text-align': 'end'
				},
				{						
					path: 'ferryDistance',
					header: 'Ferry Distance',
					width: '7em',
					'text-align': 'end'
				},
				{						
					path: 'distanceUom',
					header: 'Distance UOM',
					width: '7em'
				},
				{						
					path: 'comment',
					header: 'Comment',
					width: '7em'
				},
				{						
					path: 'entryMethodDescription',
					header: 'Entry Method',
					width: '7em'
				},
				{						
					path: 'odometer',
					header: 'Odometer',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'originalFilename',
					header: 'Original Filename',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateUser',
					header: 'Update User',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',
					hidden: true,
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var calcTotals = function(records) {			
			var totalDistance = 0;
			var totalToll = 0;
			var totalFerry = 0;
			records.forEach(function(record) {
				var distance = record.travelDistance ? record.travelDistance : 0;
				var toll = record.tollDistance ? record.tollDistance : 0;
				var ferry = record.ferryDistance ? record.ferryDistance : 0;
				
				if (record.distanceUom === 'KM') {
					totalDistance += UOMUtil.convertKMToMI(distance);
					totalToll += UOMUtil.convertKMToMI(toll);
					totalFerry += UOMUtil.convertKMToMI(ferry);
				} else {
					totalDistance += distance;
					totalToll += toll;
					totalFerry += ferry;
				}
			});
			return {
				totalDistance: Math.round(totalDistance * 10)/10,
				totalToll: Math.round(totalToll * 10)/10,
				totalFerry: Math.round(totalFerry * 10)/10
			};
		};	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {
					var totals = calcTotals(grid.selectedItems);					
					selectedDistanceStatus.innerHTML = '<b>Selected Distance:</b> ' + totals.totalDistance + 
							' Toll: ' + totals.totalToll + 
							' Ferry: ' + totals.totalFerry + 
							' MI | ';
				} else {											
					selectedDistanceStatus.innerHTML = '';
				}					
			});
		};	
		
		var selectedDistanceStatus = ElementUtil.create({
			tag: 'span'
		});
		
		var distanceStatus = ElementUtil.create({
			tag: 'span',			
			trustedInnerHTML: true,
			innerHTML: '<b>Displayed Distance:</b> 0 MI'
		});				
		
		var exportToolbar = ElementUtil.create({
			tag: 'dl-export-toolbar',
			children: [
				{
					tag: 'span',
					slot: 'status',
					children: [
						selectedDistanceStatus,						
						distanceStatus
					]
				}
			],
			listeners: {
				ready: function() {
					exportToolbar.updateGrid(grid);
				},
				'click-detail': function() {
					var companyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;						
					if (companyId) {
						DataManagementService.getAdminDataService().exportDistanceSummaries(grid.currentFilter);					
					} else {
						ElementUtil.query(toolbarFilter, 'filterCompany').validate();
						window.DL.MessageUtil.showToastError('A Company must be selected');
					}
				}
			}
		});
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
									
						var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterStartDate').value);										
						var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterEndDate').value);		
									
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'periodEndUtcDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',							
							start: startFilterDts,														
							end: endFilterDts,
							filterField: 'tractorId',
							filterValue: ElementUtil.query(toolbarFilter, 'filterTractorId').value, 
							dateField: 'periodEndUtcDts'
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];
							gridSelectionChange();
							
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();
							
							var totals = calcTotals(records.data);					
							distanceStatus.innerHTML = '<b>Displayed Distance:</b> ' + totals.totalDistance + 
							' Toll: ' + totals.totalToll + 
							' Ferry: ' + totals.totalFerry + 
							' MI | ';				
						};
						
						
						
						var companyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;
						
						if (companyId) {
							DataManagementService.getAdminDataService().getDistanceSummaries(companyId, grid.currentFilter).then(function(records){
								successHandler(records);
							});
						} else {
							loadMask.remove();
							ElementUtil.query(toolbarFilter, 'filterCompany').validate();								
							window.DL.MessageUtil.showToastError('A Company must be selected');
						}						
						
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					//pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footerContainer = ElementUtil.create({
			tag: 'div',
			slot: 'footer',
			children: [
				exportToolbar,
				{
					tag: 'div',
					style: 'border-top: 1px solid lightgrey;'
				},
				pagingToolbar
			]
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footerContainer
			]
		});		
		distanceSummaryGrid.append(flexLayout);	

		distanceSummaryGrid.actionRefresh = function() {
			pagingToolbar.loadPage(1);
		};
		attachWorkspaceFilterState(distanceSummaryGrid, toolbarFilter,
			['filterCompany','filterTractorId','filterStartDate','filterEndDate'],
			distanceSummaryGrid.actionRefresh,
			{
				save: function(state) {
					var unitState = readTypeAheadUnitState(ElementUtil.query(toolbarFilter, 'filterTractorId'));
					state.filterTractorId = unitState.value;
					state.filterTractorDescription = unitState.description;
				},
				restore: function(data) {
					if (data.filterCompany !== undefined && data.filterCompany !== null) {
						ElementUtil.query(toolbarFilter, 'filterCompany').value = data.filterCompany;
						distanceSummaryGrid.selectedCompanyId = data.filterCompany;
					}
					if (data.filterStartDate !== undefined && data.filterStartDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterStartDate').value = data.filterStartDate;
					}
					if (data.filterEndDate !== undefined && data.filterEndDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterEndDate').value = data.filterEndDate;
					}
					restoreTypeAheadUnitState({
						combo: ElementUtil.query(toolbarFilter, 'filterTractorId'),
						refType: 'TRACTOR',
						unitId: data.filterTractorId,
						description: data.filterTractorDescription,
						loadLookup: loadReferenceLookup,
						resolveByCode: function(type, unitId) {
							return resolveUnitByCode(function(referenceType, paging) {
								if (!distanceSummaryGrid.selectedCompanyId) {
									return Promise.resolve({data: []});
								}
								return UnitService.getUnitLookupService().getUnitsForCompany(
									distanceSummaryGrid.selectedCompanyId, referenceType, paging);
							}, type, unitId);
						}
					}).then(function() {
						distanceSummaryGrid.actionRefresh();
					});
				}
			});
		
	}
	
	refreshGrid() {
		var distanceSummaryGrid = this;		
		distanceSummaryGrid.actionRefresh();
	}
	
	setFilterContainer(filterContainer) {
		var distanceSummaryGrid = this;		
		distanceSummaryGrid.toolbarFilter = filterContainer;
	}
	
}
customElements.define('dl-admin-distance-summary-grid', AdminDistanceSummaryGrid);

